import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";
import { CvpEmailPhoneStatus } from "./checkEmailVerificationForCandidate";

export interface PhoneVerificationForCandidateResponse extends BackendResponse {
  item: CvpEmailPhoneStatus;
  candidatePendingPhone: string;
  idVerify: number;
  skippedCrossConcernCheckInDevmode: boolean;
}

export const checkPhoneVerification =
  withNextApi<PhoneVerificationForCandidateResponse>(
    "/cvp/CvpCheckPhoneVerification"
  );
